const SuperAdminSupport = () => import('@/modules/SuperAdmin/Support')

const NoActionSelected = () => import('@/components/SuperAdmin/Support/NoActionSelected')
const CatalogServicesAndTemplateDuplication = () => import('@/components/SuperAdmin/Support/CatalogServicesAndTemplateDuplication')
const VendorsGEDChange = () => import('@/components/SuperAdmin/Support/VendorsGEDChange')
const AddAdminHoldingRoleToUser = () => import('@/components/SuperAdmin/Support/AddAdminHoldingRoleToUser')
const DeleteNodeSurveys = () => import('@/components/SuperAdmin/Support/DeleteNodeSurveys')
const AffectThemeToUsers = () => import('@/components/SuperAdmin/Support/AffectThemeToUsers')
const DiagnosticGed = () => import('@/components/SuperAdmin/Support/DiagnosticGed')
const CatalogTreeStructureDuplication = () => import('@/components/SuperAdmin/Support/CatalogTreeStructureDuplication')
const DeleteAccountingFirmOwnUser = () => import('@/components/SuperAdmin/Support/DeleteAccountingFirmOwnUser')
const SendInvitationToUserVendor = () => import('@/components/SuperAdmin/Support/SendInvitationToUserVendor')
const CleanQuickFolders = () => import('@/components/SuperAdmin/Support/CleanQuickFolders')
const AddThemeToFolder = () => import('@/components/SuperAdmin/Support/AddThemeToFolder')
const AffectVendorsToAccountingFirmUser = () => import('@/components/SuperAdmin/Support/AffectVendorsToAccountingFirmUser')
const TestSwitchingEcm = () => import('@/components/SuperAdmin/Support/TestSwitchingEcm')
const PasswordExpiration = () => import('@/components/SuperAdmin/Support/PasswordExpiration')
const UserLoginLock = () => import('@/components/SuperAdmin/Support/UserLoginLock')

export default [
	{
		component: SuperAdminSupport,
		name: 'sa-support',
		path: 'support',
		redirect: { name: 'sa-support-no-action' },
		children: [
			{
				component: NoActionSelected,
				name: 'sa-support-no-action',
				path: ''
			},
			{
				component: CatalogServicesAndTemplateDuplication,
				name: 'sa-support-offers-template-duplicate',
				path: 'offers-template-duplicate'
			},
			{
				component: VendorsGEDChange,
				name: 'sa-support-change-geds-of-vendors',
				path: 'change-geds-of-vendors'
			},
			{
				component: AddAdminHoldingRoleToUser,
				name: 'sa-support-add-admin-holding-role-to-user',
				path: 'add-admin-holding-role-to-user'
			},
			{
				component: DeleteNodeSurveys,
				name: 'sa-support-delete-node-surveys',
				path: 'delete-node-surveys'
			},
			{
				component: AffectThemeToUsers,
				name: 'sa-support-affect-theme-to-users',
				path: 'affect-theme-to-users'
			},
			{
				component: CatalogTreeStructureDuplication,
				name: 'sa-support-catalog-tree-structure-duplicate',
				path: 'catalog-tree-structure-duplicate'
			},
			{
				component: DeleteAccountingFirmOwnUser,
				name: 'sa-support-accounting-firm-own-user-delete',
				path: 'accounting-firm-own-user-delete'
			},
			{
				component: SendInvitationToUserVendor,
				name: 'sa-support-send-invitation-to-user-vendor',
				path: 'send-invitation-to-user-vendor'
			},
			{
				component: CleanQuickFolders,
				name: 'sa-support-clean-quick-folders',
				path: 'clean-quick-folders'
			},
			{
				component: DiagnosticGed,
				name: 'sa-support-diagnostic-ged',
				path: 'diagnostic'
			},
			{
				component: AddThemeToFolder,
				name: 'sa-support-add-theme-to-folder',
				path: 'add-theme-to-folder'
			},
			{
				component: AffectVendorsToAccountingFirmUser,
				name: 'sa-support-affect-vendors-to-accounting-firm-user',
				path: 'affect-vendors-to-accounting-firm-user'
			},
			{
				component: TestSwitchingEcm,
				name: 'sa-support-test-switching-ecm',
				path: 'test-switching-ecm'
			},
			{
				component: PasswordExpiration,
				name: 'sa-support-password-expiration',
				path: 'password-expiration'
			},
			{
				component: UserLoginLock,
				name: 'sa-support-login-lock',
				path: 'login-lock'
			}
		]
	}
]
